import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThemeLight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M24 9.743C16.139 9.743 9.743 16.139 9.743 24S16.139 38.257 24 38.257 38.257 31.861 38.257 24 31.861 9.743 24 9.743m0 25.514c-6.207 0-11.257-5.05-11.257-11.257S17.793 12.743 24 12.743 35.257 17.793 35.257 24 30.207 35.257 24 35.257M22.5 0h3v5.959h-3zm0 42.041h3V48h-3zM0 22.5h5.959v3H0zm42.041 0H48v3h-5.959zM5.969 8.09l2.12-2.121 4.215 4.213-2.122 2.122zm29.727 29.724 2.121-2.121 4.214 4.213-2.122 2.122zM5.97 39.91l4.212-4.215 2.122 2.121-4.213 4.214zm29.725-29.728 4.213-4.214 2.122 2.121-4.213 4.214z" }) }) })
});
export default SvgThemeLight;
